import { useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./ui/command";
import { useCountry } from "../context/CountryContext";
import { flag } from "../lib/api";

export const CountryPicker = ({ dark = false }) => {
  const { countries, code, country, setCountry } = useCountry();
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid="country-currency-picker"
          className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-sm font-medium transition-colors ${
            dark ? "border-white/15 text-white hover:bg-white/10" : "border-border bg-white hover:bg-muted"
          }`}
        >
          <img src={flag(code)} alt="" className="h-3.5 w-5 rounded-[2px] object-cover" />
          <span className="hidden max-w-[120px] truncate whitespace-nowrap 2xl:inline">{country?.name || code}</span>
          <span className="font-mono-data text-xs opacity-70" data-testid="current-currency">{country?.currency}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="end">
        <Command>
          <CommandInput placeholder="Search 54 countries…" data-testid="country-search-input" />
          <CommandList className="max-h-80">
            <CommandEmpty>No country found.</CommandEmpty>
            {countries.map((c) => (
              <CommandItem
                key={c.code}
                value={`${c.name} ${c.code} ${c.currency}`}
                data-testid={`country-option-${c.code}`}
                onSelect={() => { setCountry(c.code); setOpen(false); }}
                className="flex items-center gap-2"
              >
                <img src={flag(c.code)} alt="" className="h-3.5 w-5 rounded-[2px] object-cover" loading="lazy" />
                <span className="flex-1 truncate">{c.name}</span>
                {!c.live && <span className="text-[10px] uppercase tracking-wide text-muted-foreground">Soon</span>}
                <span className="font-mono-data text-xs text-muted-foreground">{c.currency}</span>
                {c.code === code && <Check className="h-3.5 w-3.5 text-primary" />}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
